import React from 'react';
import ShowcaseSection from '../components/home/ShowcaseSection';
import SEOHead from '@/components/SEOHead';

export default function Portfolio() {
  return (
    <div className="bg-zinc-950 min-h-screen">
      <SEOHead
        title="Portfolio — AI-Generated Websites by BuildersLab"
        description="Browse websites built with BuildersLab's AI website builder — landing pages, web apps, e-commerce stores, mobile apps, and more."
        ogUrl="https://builderslab.net/Portfolio"
        noIndex={false}
      />

      {/* Hero */}
      <div className="pt-32 pb-4 text-center px-6 max-w-3xl mx-auto">
        <div
         
         
         
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-500/10 border border-orange-500/20 text-orange-400 text-xs font-semibold uppercase tracking-wider mb-6">
            Showcase
          </div>
          <h1 className="text-5xl md:text-6xl font-black text-white tracking-tight leading-[1.05] mb-5">
            Built with{' '}
            <span className="bg-gradient-to-r from-orange-400 via-amber-300 to-orange-500 bg-clip-text text-transparent">
              AI precision.
            </span>
          </h1>
          <p className="text-zinc-400 text-lg leading-relaxed">
            A growing archive of digital products built on the BuildersLab framework — from solo-founder MVPs to enterprise landing pages.
          </p>
        </div>
      </div>

      <ShowcaseSection extended />
    </div>
  );
}
